import React, {useEffect, useState} from "react";
import folderIcon from "../../img/folderIcon.svg";
import documentIcon from "../../img/documentIcon.svg";
import useAuth from "../../utils/CustomHooks/useAuth/useAuth";

const CargoCaseDocSetMenu = (props) => {

    const {
        onShowDocSetMenu,
        activeListOrder,
        docTypeBol,
        docTypeMan,
        docTypeOrder,
        arrayCheckCreateCargoCase,
        activeDocSetType
    } = props;

    const { getIdSelectDoc, stateReducer } = useAuth();
    const [itemsMenu, setItemsMenu] = useState([]);

    const arrCheckBoxes = [
        {checkActive: true, nameTypeDoc: 'Loading order'},
        {checkActive: true, nameTypeDoc: 'BOL'},
        {checkActive: true, nameTypeDoc: 'MAN'}
    ]

    const onHandleSelectedDoc = (docType, docId, stateReducer) => {
        if(stateReducer.idSelectDoc.idDoc === docId && stateReducer.idSelectDoc.typeDoc === docType) {
            return
        } else {
            const objSelectDoc = {
                typeDoc: docType,
                idDoc: docId
            }
            getIdSelectDoc(objSelectDoc)
            }  
        }
    
    useEffect(() => {
        let isMounted = true;

        if (arrayCheckCreateCargoCase.length > 0) {
            isMounted && setItemsMenu(arrayCheckCreateCargoCase);
        } else {
            isMounted && setItemsMenu(arrCheckBoxes);
        }

        return () => {
            isMounted = false;
        }
    },[arrayCheckCreateCargoCase.length])

    return (
        <>
            {itemsMenu.map((el, i) => {
                return (
                    <div key={i} className="cargo-case-doc-set-menu__container">
                        <div onClick={() => onShowDocSetMenu(i, el.nameTypeDoc)} className="cargo-case-doc-set-menu__item">
                            <img className="cargo-case-doc-set-menu__icon" src={folderIcon} alt={'иконка folder'}/>
                            <p className="cargo-case-doc-set-menu__name-item">{el.nameTypeDoc}</p>
                        </div>
                        <div className={activeListOrder === i ? "cargo-case-doc-set-menu__list-order" : "cargo-case-doc-set-menu__list-order hide"}>
                            {activeDocSetType === 'Loading order' && arrayCheckCreateCargoCase.length === 0 ? (
                                <>
                                    <div key={i} className="cargo-case-doc-set-menu__order">
                                        <img className="cargo-case-doc-set-menu__order-icon" src={documentIcon} alt={'иконка document'}/>
                                        <p className="cargo-case-doc-set-menu__name-order">{docTypeOrder}</p>
                                    </div>
                                </>) : null}
                            {activeDocSetType === 'BOL' && (
                                <>
                                {docTypeBol.map((el) => {
                                        return (
                                            <div onClick={() => onHandleSelectedDoc(activeDocSetType, el?.id, stateReducer)} key={el?.id} className="cargo-case-doc-set-menu__order">
                                                <img className="cargo-case-doc-set-menu__order-icon" src={documentIcon} alt={'иконка document'}/>
                                                <p className="cargo-case-doc-set-menu__name-order">{el?.bookingRef}</p>
                                            </div>
                                        )})}
                                </>)}
                            {activeDocSetType === 'MAN' && (
                                <>
                                    {docTypeMan.map((el) => {
                                        return (
                                            <div key={el?.id} className="cargo-case-doc-set-menu__order">
                                                <img className="cargo-case-doc-set-menu__order-icon" src={documentIcon} alt={'иконка document'}/>
                                                <p className="cargo-case-doc-set-menu__name-order">{el?.number}</p>
                                            </div>
                                        )})}
                                </>)}
                        </div>
                    </div>
                )})}
        </>
    )
}
export default CargoCaseDocSetMenu;